import React from "react";
import { Form, Button, Dropdown } from "semantic-ui-react";
import { useFormik } from "formik";
import { BasicModal } from "../../../Shared";
import { useLanguage } from "../../../../contexts";
import { determineWaterUnits } from "../../../../utils/dataAndFormulas/waterForms";
import "./UnitsForm.scss";

export function UnitsForm(props) {
  const { show, onClose, onSave, currentUnits, registeredFields } = props;
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  // Todos los campos de water con sus 18 campos
  const allWaterFields = [
    {
      key: "water_domestic_municipal_network",
      label: t("water_domestic_municipal_network"),
    },
    {
      key: "municipal_network_water_production",
      label: t("municipal_network_water_production"),
    },
    {
      key: "combined_municipal_network_water",
      label: t("combined_municipal_network_water"),
    },
    {
      key: "water_cost_domestic_municipal_network",
      label: t("water_cost_domestic_municipal_network"),
    },
    {
      key: "water_cost_municipal_network_production",
      label: t("water_cost_municipal_network_production"),
    },
    {
      key: "water_cost_combined_municipal_network",
      label: t("water_cost_combined_municipal_network"),
    },
    { key: "domestic_groundwater", label: t("domestic_groundwater") },
    { key: "groundwater_production", label: t("groundwater_production") },
    { key: "groundwater_combined", label: t("groundwater_combined") },
    { key: "domestic_groundwater_cost", label: t("domestic_groundwater_cost") },
    {
      key: "groundwater_production_cost",
      label: t("groundwater_production_cost"),
    },
    { key: "groundwater_combined_cost", label: t("groundwater_combined_cost") },
    { key: "rainwater", label: t("rainwater") },
    { key: "surface_water", label: t("surface_water") },
    { key: "cost_surface_water", label: t("cost_surface_water") },
    { key: "reused_water", label: t("reused_water") },
    { key: "recycled_water", label: t("recycled_water") },
    { key: "steam_condensed_water", label: t("steam_condensed_water") },
  ];

  // Si hay campos registrados en el Form, usar solo los activos; si no, usar todos
  const waterFields =
    registeredFields && registeredFields.length > 0
      ? registeredFields
          .filter((field) => field.active !== false)
          .map((field) => ({
            key: field.name,
            label: t(field.name),
          }))
      : allWaterFields;

  const formik = useFormik({
    initialValues: waterFields.reduce((acc, field) => {
      // Si ya existe una unidad guardada, usarla
      if (currentUnits?.[field.key]) {
        acc[field.key] = currentUnits[field.key];
      } else {
        // Si no hay unidad guardada, obtener las opciones disponibles
        const availableUnits = determineWaterUnits(field.key);
        // Si solo hay una opción, asignarla automáticamente
        if (availableUnits.length === 1) {
          acc[field.key] = availableUnits[0].value;
        } else {
          acc[field.key] = "";
        }
      }
      return acc;
    }, {}),
    enableReinitialize: true,
    onSubmit: (values) => {
      onSave(values);
      onClose();
    },
  });

  return (
    <BasicModal
      show={show}
      close={onClose}
      size="large"
      className="units-form-modal"
    >
      <Form onSubmit={formik.handleSubmit} className="units-form-modal">
        <div className="units-form-modal__title">{t("configure_units")}</div>
        <div className="units-grid">
          {waterFields.map((field) => (
            <div key={field.key} className="unit-row">
              <span className="unit-label">{field.label}</span>
              <Dropdown
                placeholder={t("select_unit")}
                fluid
                selection
                search
                clearable
                options={determineWaterUnits(field.key)}
                value={formik.values[field.key]}
                onChange={(_, data) =>
                  formik.setFieldValue(field.key, data.value)
                }
              />
            </div>
          ))}
        </div>

        <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "8px" }}>
          <Button primary onClick={formik.handleSubmit}>
            {t("save")}
          </Button>
          <Button onClick={onClose} className="units-btn-cancel">
            {t("cancel")}
          </Button>
        </div>
      </Form>
    </BasicModal>
  );
}
